<template>
    <div id="searchTourscope" class="shadow">
        <div class="load area" v-if="!searchValuesLoad || myHotels==null">
            <svg class="circular" viewBox="25 25 50 50">
                <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="3" stroke-miterlimit="10"></circle> 
            </svg>
        </div>
        <Form method="dialog" v-slot="{ errors }" v-if="searchValuesLoad && myHotels!=null" class="floating-labels" ref="form">
            <div class="top">
                <div class="floating-labels">
                    <div class="row">
                        <div class="col">
                            <datePicker v-model="dateRange" ref="datepicker" range :title="'Kalkış Tarih'" maxRange="31" :minDate="new Date()" :errors="errors" :rules="{required:true}"></datePicker>
                        </div>
                        <div class="col-lg-2">
                            <formGroup :title="'Acenta Komisyonu'" type="number" v-model.number="Commission" :errors="errors" :rules="{required:true}" @keydown.enter="search"></formGroup>
                        </div>
                        <div class="col-lg-1">
                            <formGroup :title="'Para'" :as="'select'" v-model="CurrencyCode" :errors="errors" @change="changeCurrency(this)">
                                <template #input>
                                    <option :value="'EUR'">EUR</option>
                                    <option :value="'USD'">USD</option>
                                    <option :value="'TRY'">TRY</option>
                                </template>
                            </formGroup>
                        </div>
                        <div class="col-lg">
                            <formGroup :title="'Günlük'" :as="'select'" v-model="model.Duration" :errors="errors">
                                <template #input>
                                    <option  v-for="item in days" :value="item.v" :key="item.v">{{item.n}}</option>
                                </template>
                            </formGroup>
                        </div>
                        <div class="col-lg">
                            <div class="form-group focused persons">
                                <input type="text" readonly class="form-control" :value="model.Adult+' Yetişkin' + (ChildCount>0?' - '+ChildCount+' Çocuk':'')" />
                                <label class="control-label">Yetişkin/Çocuk</label>
                                <div>
                                    <div>
                                        <div class="t">
                                            <strong class="box-title">Yetişkin</strong>
                                            <div>
                                                <div class="input-group bootstrap-touchspin bootstrap-touchspin-injected">
                                                    <span class="input-group-btn input-group-prepend">
                                                        <button class="btn btn-secondary btn-outline bootstrap-touchspin-down" type="button" @click="model.Adult>1?model.Adult=model.Adult-1:null">-</button>
                                                    </span>
                                                    <input id="tch3" type="text" readonly v-model="model.Adult" name="adult" data-bts-button-down-class="btn btn-secondary btn-outline text-center" data-bts-button-up-class="btn btn-secondary btn-outline" class="form-control">
                                                    <span class="input-group-btn input-group-append">
                                                        <button class="btn btn-secondary btn-outline bootstrap-touchspin-up" type="button" @click="model.Adult==null?model.Adult=1:(model.Adult<8?model.Adult++:null)">+</button>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="t">
                                            <strong class="box-title">Çocuk</strong>
                                            <div>
                                                <div class="input-group bootstrap-touchspin bootstrap-touchspin-injected">
                                                    <span class="input-group-btn input-group-prepend">
                                                        <button class="btn btn-secondary btn-outline bootstrap-touchspin-down" type="button" @click="ChildCount>0?ChildCount=ChildCount-1:null;model.Childs.splice(ChildCount,1)">-</button>
                                                    </span>
                                                    <input id="tch3" type="text" readonly v-model="ChildCount" name="child" data-bts-button-down-class="btn btn-secondary btn-outline text-center" data-bts-button-up-class="btn btn-secondary btn-outline" class="form-control">
                                                    <span class="input-group-btn input-group-append">
                                                        <button class="btn btn-secondary btn-outline bootstrap-touchspin-up" type="button" @click="ChildCount==null?ChildCount=1:(ChildCount<3?ChildCount++:null);model.Childs.push(2)">+</button>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <ul v-if="ChildCount>0">
                                            <li v-for="item,index in ChildCount" :key="item">
                                                <strong class="box-title">{{item}}. Çocuk Yaşı</strong>
                                                <div>
                                                    <select class="form-control" v-model.number="model.Childs[index]">
                                                        <option value="1">1 Yaş</option>
                                                        <option value="2">2 Yaş</option>
                                                        <option value="3">3 Yaş</option>
                                                        <option value="4">4 Yaş</option>
                                                        <option value="5">5 Yaş</option>
                                                        <option value="6">6 Yaş</option>
                                                        <option value="7">7 Yaş</option>
                                                        <option value="8">8 Yaş</option>
                                                        <option value="9">9 Yaş</option>
                                                        <option value="10">10 Yaş</option>
                                                        <option value="11">11 Yaş</option>
                                                        <option value="12">12 Yaş</option>
                                                        <option value="13">13 Yaş</option>
                                                        <option value="14">14 Yaş</option>
                                                        <option value="15">15 Yaş</option>
                                                        <option value="16">16 Yaş</option>
                                                        <option value="17">17 Yaş</option>
                                                    </select>
                                                </div>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="toggle open border-bottom">
                <div class="center">
                    <div class="row">
                        <div class="col">
                            <selectBox :title="'Oparatör'" :as="'select'" v-model="model.Operators" :errors="errors"  :rules="{required:true}">
                                <template #search>
                                    <input type="text" placeholder="Ara..." class="form-control small" v-model="searchOperator" >
                                </template>
                                <template #inputCustom>
                                    <template v-for="item in $orderByArray(searchValues.Operators,'Name',false,false)">
                                        <li class="myCheckBox" :key="item.Id" v-if="item.Name.toLowerCase().indexOf(searchOperator.toLowerCase())>-1">
                                            <input type="checkbox" class="filled-in chk-col-teal" :checked="model.Operators.indexOf(item.Id)>-1">
                                            <label @click="model.Operators.indexOf(item.Id)>-1?model.Operators=model.Operators.filter(x=>x!=item.Id):model.Operators.push(item.Id);$refs.form.validateField('Oparatör');">
                                                {{item.Name}}
                                            </label>
                                        </li>
                                    </template> 
                                </template>
                            </selectBox>
                        </div>
                        <div class="col">
                            <selectBox :title="'Oteliniz'" v-model="model.Hotels" :errors="errors" multiple :rules="{required:model.Hotels.length==0?true:false}">
                                <template #search>
                                    <input type="text" placeholder="Ara..." class="form-control small" v-model.number="searchMyHotel">
                                </template>
                                <template #inputCustom>
                                    <template v-for="item in $orderByArray(myHotels,'Name',false,false)">
                                        <li class="myCheckBox" :key="item.Id" v-if="item.Name.toLowerCase().indexOf(searchMyHotel.toLowerCase())>-1">
                                            <input type="checkbox" class="filled-in chk-col-teal" :checked="model.Hotels.indexOf(item.Id)>-1">
                                            <label @click="model.Hotels.indexOf(item.Id)>-1?model.Hotels=model.Hotels.filter(x=>x!=item.Id):model.Hotels.push(item.Id);$refs.form.validateField('Oteliniz');">
                                                {{item.Name}}
                                            </label>
                                        </li>
                                        <!-- <option :value="item.Id" :key="item.v" v-if="item.Name.toLowerCase().indexOf(searchMyHotel.toLowerCase())>-1">{{item.Name}}</option> -->
                                    </template>
                                </template>
                            </selectBox>
                        </div>
                        <div class="col">
                            <div class="treeViewInput">
                                <label>Bölge</label>
                                <div>
                                    <div>
                                        <div>
                                            <div>
                                                <input type="text" class="form-control" v-model="searchTowns" placeholder="Ara...">
                                            </div>
                                            <div v-if="Towns.length>0" @click="Towns=[];"><a href="javascript:void(0)">Sıfırla</a></div>
                                        </div>
                                    </div>
                                    <ul>
                                        <template v-for="up in $orderByArray(getDestinationTowns,'Name',false,false)" :key="up.Id">
                                            <li>
                                                <input type="checkbox" :id="'Townsearchs'+up.Id" class="filled-in chk-col-teal" :checked="Towns.indexOf(up.Id)>-1" @change="changeTown(up)">
                                                <label :for="'Townsearchs'+up.Id">
                                                    {{up.Name}}
                                                </label>
                                                <i v-if="up.Sub.length>0" @click="openTowns.indexOf(up.Id)>-1?openTowns=openTowns.filter(x=>x!=up.Id):openTowns.push(up.Id)" :class="openTowns.indexOf(up.Id)>-1?'fas fa-minus-circle':'fas fa-plus-circle'"></i>
                                                <ul class="open" v-if="up.Sub.length>0 && openTowns.indexOf(up.Id)>-1">
                                                    <template v-for="item in $orderByArray(up.Sub,'Name',false,false)" :key="item.Id">
                                                        <li>
                                                            <input type="checkbox" :id="'Townsearchs'+item.Id" class="filled-in chk-col-teal" :checked="Towns.indexOf(item.Id)>-1" @change="changeTown(item)">
                                                            <label :for="'Townsearchs'+item.Id">
                                                                {{item.Name}}
                                                            </label>
                                                            <i v-if="item.Sub.length>0" @click="openTowns.indexOf(item.Id)>-1?openTowns=openTowns.filter(x=>x!=item.Id):openTowns.push(item.Id)" :class="openTowns.indexOf(up.Id)>-1?'fas fa-minus-circle':'fas fa-plus-circle'"></i>
                                                            <ul class="open" v-if="item.Sub.length>0 && openTowns.indexOf(item.Id)>-1">
                                                                <template v-for="sub in item.Sub" :key="sub.Id">
                                                                    <li>
                                                                        <input type="checkbox" :id="'Townsearchs'+sub.Id" class="filled-in chk-col-teal" :checked="Towns.indexOf(sub.Id)>-1" @change="changeTown(sub)">
                                                                        <label :for="'Townsearchs'+sub.Id">
                                                                            {{sub.Name}}
                                                                        </label>
                                                                    </li>
                                                                </template>
                                                            </ul>
                                                        </li>
                                                    </template>
                                                </ul>
                                            </li>
                                        </template>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <selectBox :title="'Otel'" class="searchOl" :as="'select'" v-model="model.Hotels" :errors="errors" :rules="{required:model.Hotels.length==0?true:false}" @change="model.Hotels.length==0?hotelSelect=false:hotelSelect=hotelSelect">
                                <template #search>
                                    <input type="text" placeholder="Ara..." class="form-control small" v-model="searchHotel">
                                    <ul v-if="model.Hotels.length>0">
                                        <li @click="hotelSelect=false" :class="{'select':!hotelSelect}">Hepsi</li>
                                        <li @click="hotelSelect=true" :class="{'select':hotelSelect}">Seçilenler({{model.Hotels.length}})</li>
                                        <li @click="model.Hotels=[]; hotelSelect=false">Sıfırla</li>
                                    </ul>
                                    <ol>
                                        <li v-for="item in searchValues.Stars" :key="item" class="myCheckBox">
                                            <input type="checkbox" class="filled-in chk-col-teal" :checked="stars.indexOf(item)>-1">
                                            <label @click="stars.indexOf(item)>-1?stars=stars.filter(x=>x!=item):stars.push(item)">
                                                {{item}}
                                            </label>
                                        </li>
                                    </ol>
                                </template>
                                <template #inputCustom>
                                    <template v-for="item in $orderByArray(searchValues.Hotels,'Name',false,false)">
                                        <li class="myCheckBox" :key="item.Id" v-if="(Towns.length==0 || Towns.indexOf(item.DestinationTownId)>-1) && stars.indexOf(item.Star)>-1 && item.Name.toLowerCase().indexOf(searchHotel.toLowerCase())>-1 && (!hotelSelect || model.Hotels.indexOf(item.Id)>-1)">
                                            <input type="checkbox" class="filled-in chk-col-teal" :checked="model.Hotels.indexOf(item.Id)>-1">
                                            <label :for="'hotel'+item.Id" @click="changeHotelsInput(item)">
                                                {{item.Name}}
                                            </label>
                                        </li>
                                    </template>
                                </template>
                            </selectBox>
                        </div>
                    </div>
                </div>
            </div>
            <div class="action row align-items-center">   
                <div class="col-auto tleft">
                    <div class="myCheckBox">
                        <input type="checkbox" class="filled-in" id="Recreate" v-model="model.Recreate"> 
                        <label for="Recreate">Recreate</label>
                    </div>
                </div>
                <div class="col tleft floating-labels">
                    <div class="form-group">
                        <select class="form-control" v-model.number="model.ScanModel">
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                        </select>
                    </div>
                </div>
                <div class="col-auto">
                    <Btn class="btn btn-primary waves-effect text-left" @click="test"><span class="p-l-20 p-r-20">test</span> </Btn>
                </div>
                <div class="col-auto">
                    <Btn class="btn btn-primary waves-effect text-left" @click="createScanItems"><span class="p-l-20 p-r-20">Create Scan Items</span> </Btn>
                </div>
                <div class="col-auto">
                    <Btn class="btn btn-warning waves-effect text-left" @click="search" :process="process"><span class="p-l-20 p-r-20">Raporla</span> </Btn>
                </div>
            </div>
        </Form>
    </div>
    <pre v-if="err!=null">{{err}}</pre>
    <div class="card m-t-20" v-if="err==null" v-show="openReport!=null">
        <ul class="nav nav-tabs profile-tab border-bottom">
            <li class="nav-item">
                <a href="javascript:;" class="nav-link" :class="{'active':tab==1}" @click="tab=1">Rapor 1</a>
            </li>
            <li class="nav-item">
                <a href="javascript:;" class="nav-link" :class="{'active':tab==2}" @click="tab=2">Rapor 2</a>
            </li>
            <li class="nav-item">
                <a href="javascript:;" class="nav-link" :class="{'active':tab==3}" @click="tab=3">Grafik</a>
            </li>
        </ul>
        <div class="p-10">
            <div class="row align-items-center justify-content-end">
                <div class="col-auto" v-if="openReport!=null && openReport.MinPrices.length>=totalPriceCount-100">
                    <formGroup :title="'Colorize'" :as="'checkbox'" class="m-b-0" v-model="colorize" @change="setColor(this)"></formGroup>
                </div>
                <div class="col-auto">
                    <formGroup :title="'PP'" :as="'checkbox'" class="m-b-0" v-model="priceShow.PP" @change="colspan=Object.keys(priceShow).filter(x=>{return priceShow[x]}).length"></formGroup>
                </div>
                <div class="col-auto">
                    <formGroup :title="'Daily'" :as="'checkbox'" class="m-b-0" v-model="priceShow.Daily" @change="colspan=Object.keys(priceShow).filter(x=>{return priceShow[x]}).length"></formGroup>
                </div>
                <div class="col-auto">
                    <formGroup :title="'DBL'" :as="'checkbox'" class="m-b-0" v-model="priceShow.DBL" @change="colspan=Object.keys(priceShow).filter(x=>{return priceShow[x]}).length"></formGroup>
                </div>
                <div class="col-auto">
                    <formGroup :title="'Acenta Komisyonu'" :as="'checkbox'" class="m-b-0" v-model="isCommission"></formGroup>
                </div>
                <div class="col-auto">
                    <button :disabled="openReport!=null && openReport.MinPrices.length<=totalPriceCount-100" @click="exportExcel==null?exportExcel=1:exportExcel++;" class="btn btn-xs btn-info waves-effect waves-light" type="button"><span class="btn-label"><i class="fa fa-file-excel"></i></span>Excel'e Aktar</button>
                </div>
            </div>
        </div>
        <div class="progress" v-if="openReport!=null">
            <div class="progress-bar bg-success" :style="'width: '+(100/totalPriceCount*openReport.MinPrices.length)+'%;'" role="progressbar">{{Math.floor(100/totalPriceCount*openReport.MinPrices.length)}}% ({{openReport.MinPrices.length}}/{{totalPriceCount}})</div>
        </div>
        <report v-if="tab==1 && openReport!=null" 
            :operationData="openReport" 
            :schema="reports.one" 
            :key="model.Key" 
            :Commission="Commission" 
            :colorize="colorize" 
            :isCommission="isCommission" 
            :priceShow="priceShow" 
            :colspan="colspan" 
            :CurrencyCode="CurrencyCode" 
            :exportExcel="exportExcel">
        </report>
        <report2 v-if="tab==2 && openReport!=null" 
            :operationData="openReport" :schema="reports.two" 
            :key="model.Key" 
            :Commission="Commission" 
            :colorize="colorize" 
            :isCommission="isCommission" 
            :priceShow="priceShow" 
            :colspan="colspan" 
            :CurrencyCode="CurrencyCode"
            :totalPriceCount="totalPriceCount" 
            :exportExcel="exportExcel">
        </report2>
        <chart v-if="tab==3 && openReport!=null" :setReportCount="openReport?.MinPrices.length" :operationData="openReport" :model="model" :key="model.Key" :Commission="Commission" :CurrencyCode="CurrencyCode" :process="process"></chart>
    </div>
    <createScanItems v-if="createScanItemsOpen>0" :open="createScanItemsOpen" :model="model"></createScanItems>
    <!-- <report :Commission="Commission" :CurrencyId="CurrencyId"></report> -->
</template>

<script>
    import datePicker from "../../../components/formGroup/rangeDatePicker.vue"
    import selectBox from "../../../components/formGroup/selectBox.vue"
    import report from "./report.vue";
    import report2 from "./report2.vue";
    import chart from "./chart.vue";
    import createScanItems from "../scans/createScanItems/main";
    import {mapState} from "vuex";
    export default {
        name:"Scans",
        components:{datePicker,selectBox,report,report2,chart,createScanItems},
        data(){
            return {
                searchValuesLoad:false,
                searchValues:{},
                myHotels:null,
                dateRange:[],
                searchCountry:"",
                searchDeparture:"",
                searchOperator:"",
                searchDay:"",
                searchMyHotel:"",
                searchTowns:"",
                searchStar:"",
                searchHotel:"",
                hotelSelect:false,
                days:[{n:'7',v:7},{n:'10',v:10},{n:'14',v:14}],
                Endex:[{v:1,n:'En Düşük'},{v:2,n:'Ortalama'},{v:3,n:'Ortanca'},{v:4,n:'En Yüksek'}],
                openTowns:[],
                open:false,
                ChildCount:0,
                Towns:[],
                stars:[],
                Commission:10,
                CurrencyCode:"TRY",
                model:{
                    ConnectionId:this.$root.socket.connection.connectionId,
                    ReportKey:this.$uniqueid(),
                    DepartureCityId:null,
                    Duration:7,
                    Adult:2,
                    Childs:[],
                    StartDate:null,
                    EndDate:null,
                    Operators:[],
                    Hotels:[],
                    Recreate:false,
                    ScanModel:1
                },
                searchResponse:null,
                openReport:null,
                process:false,
                addPrices:null,
                tab:1,
                err:null,
                createScanItemsOpen:0,
                
                colspan:3,
                totalPriceCount:0,
                reports:{
                    one:{},
                    two:{}
                },
                priceShow:{
                    PP:true,
                    Daily:true,
                    DBL:true
                },
                isCommission:false,
                colorize:false,
                exportExcel:null
            }
        },
        created(){
            this.dateRange.push(new Date());
            this.dateRange.push(new Date());
            this.dateRange[1].setDate(this.dateRange[1].getDate()+6);
            this.$appAxiosTourscope.get(`LocalCompareHotelsItems/228`).then(response=>{
                this.searchValues=response.data;
                this.stars=this.searchValues.Stars;
                this.searchValuesLoad=true;
            });
            this.$appAxiosAdmin.get(`CustomerHotels`).then(response => {
                this.myHotels=response.data;
            });
            this.$root.socket.on("ReceiveCompareHotelsPrices", (data) => {
                console.log(data);
                this.setSocketData(data,this);
            });
        },
        methods:{
            changeHotelsInput(item){
                this.model.Hotels.indexOf(item.Id)>-1?this.model.Hotels=this.model.Hotels.filter(x=>x!=item.Id):this.model.Hotels.push(item.Id)
                if(this.model.Hotels.length==0){
                    this.hotelSelect=false;
                }
            },
            setSocketData:async(data,app)=>{
                if(data.ReportKey==app.openReport?.ReportKey){
                    data.MinPrices.forEach(item => {
                        app.setSocketDataOne(item,app);
                        app.setSocketDataTwo(item,app);

                        app.openReport.MinPrices.push({...item,OperatorId:data.OperatorId,Errors:data.Errors});
                    });
                    data.Prices.forEach(element => {
                        app.openReport.Prices.push({...element,OperatorId:data.OperatorId});
                    });
                    if(app.colorize && app.openReport.MinPrices.length>=app.totalPriceCount-100){
                        app.setColor(app);
                    }
                }
            },
            setSocketDataOne:async(item,app)=>{
                app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].currencyCode=item.CurrencyCode;
                app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].duration=item.Duration;
                app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].pp=item.PP;
                app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].dbl=item.DBL;
                app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].package=item.Package;
                app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].daily=item.Daily;
                app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].color="";
                if(app.CurrencyCode!=item.CurrencyCode){
                    app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].ppFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[item.OperatorId].EUR,USD:app.openReport.operatorsSchema[item.OperatorId].USD},item.CurrencyCode,item.PP,app.CurrencyCode,"TRY")
                    app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].dblFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[item.OperatorId].EUR,USD:app.openReport.operatorsSchema[item.OperatorId].USD},item.CurrencyCode,item.DBL,app.CurrencyCode,"TRY")
                    app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].packageFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[item.OperatorId].EUR,USD:app.openReport.operatorsSchema[item.OperatorId].USD},item.CurrencyCode,item.Package,app.CurrencyCode,"TRY")
                    app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].dailyFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[item.OperatorId].EUR,USD:app.openReport.operatorsSchema[item.OperatorId].USD},item.CurrencyCode,item.Daily,app.CurrencyCode,"TRY")
                }else{
                    app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].ppFormat=item.PP;
                    app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].dblFormat=item.DBL;
                    app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].packageFormat=item.Package;
                    app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].dailyFormat=item.Daily;
                }
                app.reports.one[item.Checkin.toString()][item.HotelId].oparators[item.OperatorId].errors=item.Errors;

                if(item.PP>0 && (app.openReport.operatorsSchema[item.OperatorId].summary.one.pp.cheap==null || app.openReport.operatorsSchema[item.OperatorId].summary.one.pp.cheap>item.PP)){
                    app.openReport.operatorsSchema[item.OperatorId].summary.one.pp.cheap=item.PP;
                }
                if(item.PP>0 && (app.openReport.operatorsSchema[item.OperatorId].summary.one.pp.expensive==null || app.openReport.operatorsSchema[item.OperatorId].summary.one.pp.expensive<item.PP)){
                    app.openReport.operatorsSchema[item.OperatorId].summary.one.pp.expensive=item.PP;
                }
                
                if(item.Daily>0 && (app.openReport.operatorsSchema[item.OperatorId].summary.one.daily.cheap==null || app.openReport.operatorsSchema[item.OperatorId].summary.one.daily.cheap>item.Daily)){
                    app.openReport.operatorsSchema[item.OperatorId].summary.one.daily.cheap=item.Daily;
                }
                if(item.Daily>0 && (app.openReport.operatorsSchema[item.OperatorId].summary.one.daily.expensive==null || app.openReport.operatorsSchema[item.OperatorId].summary.one.daily.expensive<item.Daily)){
                    app.openReport.operatorsSchema[item.OperatorId].summary.one.daily.expensive=item.Daily;
                }
                
                if(item.DBL>0 && (app.openReport.operatorsSchema[item.OperatorId].summary.one.dbl.cheap==null || app.openReport.operatorsSchema[item.OperatorId].summary.one.dbl.cheap>item.DBL)){
                    app.openReport.operatorsSchema[item.OperatorId].summary.one.dbl.cheap=item.DBL;
                }
                if(item.DBL>0 && (app.openReport.operatorsSchema[item.OperatorId].summary.one.dbl.expensive==null || app.openReport.operatorsSchema[item.OperatorId].summary.one.dbl.expensive<item.DBL)){
                    app.openReport.operatorsSchema[item.OperatorId].summary.one.dbl.expensive=item.DBL;
                }
            },
            setSocketDataTwo:async(item,app)=>{
                app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].currencyCode=item.CurrencyCode;
                app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].duration=item.Duration;
                app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].pp=item.PP;
                app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].dbl=item.DBL;
                app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].package=item.Package;
                app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].daily=item.Daily;
                app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].color="";
                if(app.CurrencyCode!=item.CurrencyCode){
                    app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].ppFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[item.OperatorId].EUR,USD:app.openReport.operatorsSchema[item.OperatorId].USD},item.CurrencyCode,item.PP,app.CurrencyCode,"TRY")
                    app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].dblFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[item.OperatorId].EUR,USD:app.openReport.operatorsSchema[item.OperatorId].USD},item.CurrencyCode,item.DBL,app.CurrencyCode,"TRY")
                    app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].packageFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[item.OperatorId].EUR,USD:app.openReport.operatorsSchema[item.OperatorId].USD},item.CurrencyCode,item.Package,app.CurrencyCode,"TRY")
                    app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].dailyFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[item.OperatorId].EUR,USD:app.openReport.operatorsSchema[item.OperatorId].USD},item.CurrencyCode,item.Daily,app.CurrencyCode,"TRY")
                }else{
                    app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].ppFormat=item.PP;
                    app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].dblFormat=item.DBL;
                    app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].packageFormat=item.Package;
                    app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].dailyFormat=item.Daily;
                }
                app.reports.two[item.Checkin.toString()][item.OperatorId].hotels[item.HotelId].errors=item.Errors;

                if(item.PP>0 && (app.openReport.hotelsSchema[item.HotelId].summary.two.pp.cheap==null || app.openReport.hotelsSchema[item.HotelId].summary.two.pp.cheap>item.PP)){
                    app.openReport.hotelsSchema[item.HotelId].summary.two.pp.cheap=item.PP;
                }
                if(item.PP>0 && (app.openReport.hotelsSchema[item.HotelId].summary.two.pp.expensive==null || app.openReport.hotelsSchema[item.HotelId].summary.two.pp.expensive<item.PP)){
                    app.openReport.hotelsSchema[item.HotelId].summary.two.pp.expensive=item.PP;
                }
                
                if(item.Daily>0 && (app.openReport.hotelsSchema[item.HotelId].summary.two.daily.cheap==null || app.openReport.hotelsSchema[item.HotelId].summary.two.daily.cheap>item.Daily)){
                    app.openReport.hotelsSchema[item.HotelId].summary.two.daily.cheap=item.Daily;
                }
                if(item.Daily>0 && (app.openReport.hotelsSchema[item.HotelId].summary.two.daily.expensive==null || app.openReport.hotelsSchema[item.HotelId].summary.two.daily.expensive<item.Daily)){
                    app.openReport.hotelsSchema[item.HotelId].summary.two.daily.expensive=item.Daily;
                }
                
                if(item.DBL>0 && (app.openReport.hotelsSchema[item.HotelId].summary.two.dbl.cheap==null || app.openReport.hotelsSchema[item.HotelId].summary.two.dbl.cheap>item.DBL)){
                    app.openReport.hotelsSchema[item.HotelId].summary.two.dbl.cheap=item.DBL;
                }
                if(item.DBL>0 && (app.openReport.hotelsSchema[item.HotelId].summary.two.dbl.expensive==null || app.openReport.hotelsSchema[item.HotelId].summary.two.dbl.expensive<item.DBL)){
                    app.openReport.hotelsSchema[item.HotelId].summary.two.dbl.expensive=item.DBL;
                }
            },
            changeCurrency:async(app)=>{
                Object.entries(app.reports.one).forEach(date => {
                    Object.entries(date[1]).forEach(hotel => {
                        Object.entries(hotel[1].oparators).forEach(item => {
                            if(app.CurrencyCode!=item[1].currencyCode){
                                app.reports.one[date[0]][hotel[0]].oparators[item[0]].ppFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[item[0]].EUR,USD:app.openReport.operatorsSchema[item[0]].USD},item[1].currencyCode,item[1].pp,app.CurrencyCode,"TRY")
                                app.reports.one[date[0]][hotel[0]].oparators[item[0]].dblFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[item[0]].EUR,USD:app.openReport.operatorsSchema[item[0]].USD},item[1].currencyCode,item[1].dbl,app.CurrencyCode,"TRY")
                                app.reports.one[date[0]][hotel[0]].oparators[item[0]].packageFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[item[0]].EUR,USD:app.openReport.operatorsSchema[item[0]].USD},item[1].currencyCode,item[1].package,app.CurrencyCode,"TRY")
                                app.reports.one[date[0]][hotel[0]].oparators[item[0]].dailyFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[item[0]].EUR,USD:app.openReport.operatorsSchema[item[0]].USD},item[1].currencyCode,item[1].daily,app.CurrencyCode,"TRY")
                            }else{
                                app.reports.one[date[0]][hotel[0]].oparators[item[0]].ppFormat=item[1].pp;
                                app.reports.one[date[0]][hotel[0]].oparators[item[0]].dblFormat=item[1].dbl;
                                app.reports.one[date[0]][hotel[0]].oparators[item[0]].packageFormat=item[1].package;
                                app.reports.one[date[0]][hotel[0]].oparators[item[0]].dailyFormat=item[1].daily;
                            }
                        });
                    });
                });
                Object.entries(app.reports.two).forEach(date => {
                    Object.entries(date[1]).forEach(operator => {
                        Object.entries(operator[1].hotels).forEach(item => {
                            if(app.CurrencyCode!=item[1].currencyCode){
                                app.reports.two[date[0]][operator[0]].hotels[item[0]].ppFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[operator[0]].EUR,USD:app.openReport.operatorsSchema[operator[0]].USD},item[1].currencyCode,item[1].pp,app.CurrencyCode,"TRY")
                                app.reports.two[date[0]][operator[0]].hotels[item[0]].dblFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[operator[0]].EUR,USD:app.openReport.operatorsSchema[operator[0]].USD},item[1].currencyCode,item[1].dbl,app.CurrencyCode,"TRY")
                                app.reports.two[date[0]][operator[0]].hotels[item[0]].packageFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[operator[0]].EUR,USD:app.openReport.operatorsSchema[operator[0]].USD},item[1].currencyCode,item[1].package,app.CurrencyCode,"TRY")
                                app.reports.two[date[0]][operator[0]].hotels[item[0]].dailyFormat=app.$exchangeCurrency({EUR:app.openReport.operatorsSchema[operator[0]].EUR,USD:app.openReport.operatorsSchema[operator[0]].USD},item[1].currencyCode,item[1].daily,app.CurrencyCode,"TRY")
                            }else{
                                app.reports.two[date[0]][operator[0]].hotels[item[0]].ppFormat=item[1].pp;
                                app.reports.two[date[0]][operator[0]].hotels[item[0]].dblFormat=item[1].dbl;
                                app.reports.two[date[0]][operator[0]].hotels[item[0]].packageFormat=item[1].package;
                                app.reports.two[date[0]][operator[0]].hotels[item[0]].dailyFormat=item[1].daily;
                            }
                        });
                    });
                });
            },
            setColor:async(app)=>{
                app.setColorOne(app);
                app.setColorTwo(app);
            },
            setColorOne:async(app)=>{
                let lowPrice,highPrice,diff;
                app.openReport.Operators.forEach(operator => {
                    Object.entries(app.reports.one).forEach(date => {
                        let prices={};
                        Object.entries(date[1]).forEach(hotel => {
                            if(hotel[1].oparators[operator.Id].pp!=null && hotel[1].oparators[operator.Id].pp>0){
                                prices[hotel[0]]=hotel[1].oparators[operator.Id].pp;
                            }
                        });
                        if(Object.entries(prices).filter((x,y)=>{return x[1]!=y[1]}).length>0){
                            highPrice=Object.entries(prices).sort((x,y)=>x[1]-y[1])[Object.entries(prices).sort((x,y)=>x[1]-y[1]).length-1][1];
                            lowPrice=Object.entries(prices).sort((x,y)=>x[1]-y[1])[0][1];
                            diff=(highPrice-lowPrice)/10;
                            if(diff>0){
                                Object.entries(date[1]).forEach(hotel => {
                                    app.reports.one[date[0]][hotel[0]].oparators[operator.Id].color="orderColor"+(Math.round((hotel[1].oparators[operator.Id].pp-lowPrice)/diff)==0?1:Math.round((hotel[1].oparators[operator.Id].pp-lowPrice)/diff));
                                });
                            }
                        }
                    });
                });
            },
            setColorTwo:async(app)=>{
                var lowPrice,highPrice,diff;
                app.openReport.Hotels.forEach(hotel => {
                    Object.entries(app.reports.two).forEach(date => {
                        let prices={};
                        Object.entries(date[1]).forEach(operator => {
                            if(operator[1].hotels[hotel.Id].pp!=null && operator[1].hotels[hotel.Id].pp>0){
                                prices[operator[0]]=operator[1].hotels[hotel.Id].pp;
                            }
                        });
                        if(Object.keys(prices).length>0){
                            highPrice=Object.entries(prices).sort((x,y)=>x[1]-y[1])[Object.entries(prices).sort((x,y)=>x[1]-y[1]).length-1][1];
                            lowPrice=Object.entries(prices).sort((x,y)=>x[1]-y[1])[0][1];
                            diff=(highPrice-lowPrice)/10;
                            if(diff>0){
                                Object.entries(date[1]).forEach(operator => {
                                    app.reports.two[date[0]][operator[0]].hotels[hotel.Id].color="orderColor"+(Math.round((operator[1].hotels[hotel.Id].pp-lowPrice)/diff)==0?1:Math.round((app.reports.two[date[0]][operator[0]].hotels[hotel.Id].pp-lowPrice)/diff));
                                });
                            }else{
                                Object.entries(date[1]).forEach(operator => {
                                    app.reports.two[date[0]][operator[0]].hotels[hotel.Id].color="";
                                });
                            }
                        }
                    });
                });
            },
            test(){
                this.model={"ConnectionId":"W9i9aLipLJ9n4ja_mjf8UA","ReportKey":"uid17983786694547","DepartureCityId":null,"Duration":7,"Adult":2,"Childs":[],"StartDate":"2022-08-19","EndDate":"2022-08-25","Operators":[48,37,39,73,35,47,38,33,40,72,34,36,46],"Hotels":[3271,3272,3273,3274,3275,3276],"Recreate":true,"ScanModel":1};
                this.model={"ReportKey":"uid33248924438527","DepartureCityId":null,"Duration":7,"Adult":2,"Childs":[],"StartDate":"2022-09-04","EndDate":"2022-09-10","Operators":[48,37,39],"Hotels":[1366,2432,2489,2490],"Recreate":true,"ScanModel":1}
                // this.model={"ConnectionId":"W9i9aLipLJ9n4ja_mjf8UA","ReportKey":"uid17983786694547","DepartureCityId":null,"Duration":7,"Adult":2,"Childs":[],"StartDate":"2022-08-19","EndDate":"2022-08-25","Operators":[35, 47, 36],"Hotels":[3271,3272,3273,3274,3275,3276],"Recreate":true,"ScanModel":1};
                // this.model={"ConnectionId":"aNSNYwfWjegfk-7k_2Q8lw","ReportKey":"uid17605213329598","DepartureCityId":null,"Duration":7,"Adult":2,"Childs":[],"StartDate":"2022-08-22","EndDate":"2022-08-23","Operators":[48, 33, 36, 46],"Hotels":[3271],"Recreate":true,"ScanModel":1}
                // this.model={"ConnectionId":"W9i9aLipLJ9n4ja_mjf8UA","ReportKey":"uid17983786694547","DepartureCityId":null,"Duration":7,"Adult":2,"Childs":[],"StartDate":"2022-08-19","EndDate":"2022-08-25","Operators":[48,37],"Hotels":[3271,3272],"Recreate":true,"ScanModel":1};
                // this.model={"ConnectionId":"W9i9aLipLJ9n4ja_mjf8UA","ReportKey":"uid17983786694547","DepartureCityId":null,"Duration":7,"Adult":2,"Childs":[],"StartDate":"2022-08-19","EndDate":"2022-08-25","Operators":[48, 47],"Hotels":[3271, 3276],"Recreate":true,"ScanModel":1};
                setTimeout(() => {
                    this.search();
                }, 500);
            },
            search(){
                this.$refs.form.validate().then(valid =>{
                    if(valid.valid){
                        this.exportExcel=null;
                        var startDate=new Date(this.dateRange[0]);
                        var endDate=new Date(this.dateRange[1]);
                        this.model.ConnectionId=this.$root.socket.connection.connectionId;
                        this.model.ReportKey=this.$uniqueid();
                        this.model.StartDate=startDate.getFullYear()+"-"+((startDate.getMonth()+1)<10?"0"+(startDate.getMonth()+1):startDate.getMonth()+1)+"-"+(startDate.getDate()<10?"0"+startDate.getDate():startDate.getDate());
                        this.model.EndDate=endDate.getFullYear()+"-"+((endDate.getMonth()+1)<10?"0"+(endDate.getMonth()+1):endDate.getMonth()+1)+"-"+(endDate.getDate()<10?"0"+endDate.getDate():endDate.getDate());
                        this.process=true;
                        this.$appAxiosTourscope.post(`CompareHotelPrices`,this.model).then(response=>{
                            this.openReport={
                                ...response.data,
                                MinPrices:response.data.Prices==null?[]:response.data.Prices,
                                Prices:[],
                                operatorsSchema:{},
                                hotelsSchema:{}
                            };
                            response.data.Operators.forEach(element => {
                                this.openReport.operatorsSchema[element.Id]={
                                    ...element,
                                    summary:{
                                        one:{
                                            pp:{
                                                cheap:null,
                                                expensive:null
                                            },
                                            daily:{
                                                cheap:null,
                                                expensive:null
                                            },
                                            dbl:{
                                                cheap:null,
                                                expensive:null
                                            }
                                        }
                                    }
                                };
                            });
                            response.data.Hotels.forEach(element => {
                                this.openReport.hotelsSchema[element.Id]={
                                    ...element,
                                    summary:{
                                        two:{
                                            pp:{
                                                cheap:null,
                                                expensive:null
                                            },
                                            daily:{
                                                cheap:null,
                                                expensive:null
                                            },
                                            dbl:{
                                                cheap:null,
                                                expensive:null
                                            }
                                        }
                                    }
                                };
                            });
                            let totalHotelCount=0;
                            response.data.Operators.forEach(element => {
                                totalHotelCount+=element.Hotels.length;
                            });
                            this.totalPriceCount=totalHotelCount*response.data.Dates.length;
                            this.setReports(response.data);
                            this.process=false;
                        }).catch(err=>{
                            this.err=err;
                            this.process=false;
                        });
                    }
                });
            },
            changeTown(data){
                if(this.Towns.indexOf(data.Id)>-1){
                    this.Towns=this.Towns.filter(x=>x!=data.Id);
                    data.Sub.forEach(sub => {
                        if(this.Towns.indexOf(sub.Id)>-1){
                            this.changeTown(sub)
                        }
                    });
                }else{
                    this.Towns.push(data.Id);
                    data.Sub.forEach(sub => {
                        if(this.Towns.indexOf(sub.Id)==-1){
                            this.changeTown(sub)
                        }
                    });
                }
            },
            getSubDestinationTowns(id){
                var data=[];
                this.searchValues.DestinationTowns.filter(x=>x.SubId==id).forEach(element => {
                    data.push({
                        Id:element.Id,
                        Name:element.Name,
                        Sub:this.getSubDestinationTowns(element.Id)
                    });
                });
                return data;
            },
            createScanItems(){
                this.$refs.form.validate().then(valid =>{
                    if(valid.valid){
                        var startDate=new Date(this.dateRange[0]);
                        var endDate=new Date(this.dateRange[1]);
                        this.model.ReportKey=this.$uniqueid();
                        this.model.StartDate=startDate.getFullYear()+"-"+((startDate.getMonth()+1)<10?"0"+(startDate.getMonth()+1):startDate.getMonth()+1)+"-"+(startDate.getDate()<10?"0"+startDate.getDate():startDate.getDate());
                        this.model.EndDate=endDate.getFullYear()+"-"+((endDate.getMonth()+1)<10?"0"+(endDate.getMonth()+1):endDate.getMonth()+1)+"-"+(endDate.getDate()<10?"0"+endDate.getDate():endDate.getDate());
                        this.openReport=null;
                        this.createScanItemsOpen++;
                    }
                });
            },
            setReports(data){
                this.reports.one={};
                data.Dates.forEach(date => {
                    this.reports.one[date]={};
                    data.Hotels.forEach(hotel => {
                        this.reports.one[date][hotel.Id]={
                            ...hotel,
                            oparators:{}
                        };
                        data.Operators.forEach(operator => {
                            var prices=[];
                            data.Prices.forEach(price => {
                                if(price.Checkin==date && price.HotelId==hotel.Id && price.OperatorId==operator.Id){
                                    prices.push(price);
                                }
                            });
                            this.reports.one[date][hotel.Id].oparators[operator.Id]={
                                ...operator,
                                    colorClass:"",
                                    pp:operator.Hotels.indexOf(hotel.Id)>-1?-1:"X",
                                    dbl:operator.Hotels.indexOf(hotel.Id)>-1?-1:"X",
                                    package:operator.Hotels.indexOf(hotel.Id)>-1?-1:"X",
                                    daily:operator.Hotels.indexOf(hotel.Id)>-1?-1:"X",
                                    ppFormat:"",
                                    dblFormat:"",
                                    packageFormat:"",
                                    dailyFormat:"",
                                    duration:null,
                                    currencyCode:null,
                                    prices:prices,
                                    errors:[]
                            };
                        });
                    });
                });

                this.reports.two={};
                data.Dates.forEach(date => {
                    this.reports.two[date]={};
                    data.Operators.forEach(operator => {
                        this.reports.two[date][operator.Id]={
                            ...operator,
                            currencyCode:null,
                            hotels:{}
                        };
                        data.Hotels.forEach(hotel => {
                            this.reports.two[date][operator.Id].hotels[hotel.Id]={
                                ...hotel,
                                colorClass:"",
                                pp:operator.Hotels.indexOf(hotel.Id)>-1?-1:"X",
                                dbl:operator.Hotels.indexOf(hotel.Id)>-1?-1:"X",
                                dblchd:operator.Hotels.indexOf(hotel.Id)>-1?-1:"X",
                                package:operator.Hotels.indexOf(hotel.Id)>-1?-1:"X",
                                daily:operator.Hotels.indexOf(hotel.Id)>-1?-1:"X",
                                flight:operator.Hotels.indexOf(hotel.Id)>-1?-1:"X",
                                ppFormat:"",
                                dblFormat:"",
                                packageFormat:"",
                                dailyFormat:"",
                                duration:null,
                                prices:[],
                                errors:[]
                            };
                        });
                    });
                });
            }
        },
        computed:{
            ...mapState(["user"]),
            getDestinationTowns(){
                var data=[]
                this.searchValues.DestinationTowns.filter(x=>x.SubId==null).forEach(element => {
                    data.push({
                        Id:element.Id,
                        Name:element.Name,
                        Sub:this.getSubDestinationTowns(element.Id)
                    });
                });
                return data;
            }
        }
    }
</script>

<style scoped>
    #searchTourscope .action .myCheckBox label{
        padding-top:0;
        padding-bottom:0;
        line-height:20px;
        background:none;
        heighT:auto;
    }
</style>